import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ title, description, keywords, schema, canonical }) => {
  const siteUrl = 'https://ausbau.nrw';
  
  // Logik zur Generierung der Canonical URL
  // Ziel: Absolute URL, HTTPS, kein Trailing Slash (außer Startseite), keine Parameter
  
  let canonicalUrl = siteUrl;
  
  if (canonical) {
    if (canonical === '/') {
      // Startseite: https://ausbau.nrw/
      canonicalUrl = `${siteUrl}/`;
    } else {
      // Unterseiten: https://ausbau.nrw/pfad (ohne Trailing Slash)
      // 1. Sicherstellen, dass Pfad mit / beginnt
      const cleanPath = canonical.startsWith('/') ? canonical : `/${canonical}`;
      
      // 2. Trailing Slash entfernen, falls vorhanden (außer es ist nur /)
      const noTrailingSlash = cleanPath.endsWith('/') && cleanPath !== '/' 
        ? cleanPath.slice(0, -1) 
        : cleanPath;
        
      // 3. Zusammenbauen
      canonicalUrl = `${siteUrl}${noTrailingSlash}`;
    }
  } else {
    // Fallback: Wenn kein Canonical übergeben wurde, nutzen wir die Startseite
    // (Sollte in der Praxis vermieden werden, jede Seite sollte explizit sein)
    canonicalUrl = `${siteUrl}/`;
  }

  const fullTitle = title.includes('|') ? title : `${title} | MK-AUSBAU Heinsberg`;

  return (
    <Helmet>
      {/* Standard Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      
      {/* Canonical Tag - Strikt und bereinigt */}
      <link rel="canonical" href={canonicalUrl} />

      {/* Robots & AI Control Tags */}
      <meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />
      <meta name="googlebot" content="index, follow" />
      
      {/* Open Graph / Facebook / LinkedIn */}
      <meta property="og:type" content="website" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:site_name" content="MK-AUSBAU" />
      <meta property="og:image" content={`${siteUrl}/logo-icon.svg`} />

      {/* Twitter Cards */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />

      {/* Structured Data (JSON-LD) */}
      {schema && (
        <script type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      )}
    </Helmet>
  );
};

export default SEO;